import * as React from 'react';
import {useTranslation} from "react-i18next";
import {data} from "../Store/Data";

const UpsLivecamsText = () => {
	const {t} = useTranslation();
	const ab1 = data('ab1').asBool()
	const bonus = data('bonus').asString();

	if (bonus !== "") {
		return <>
			<p className="reset-margin text-align-center">{t('Bis zu 250€ Geschenkt')}</p>
			<small className="text-align-center">{t('Für Erstkunden zum Erkunden')}</small>
		</>
	}

	if (ab1) {
		return <>
			<p className="reset-margin text-align-center">{t('100% Bonus')}</p>
			<small
				className="text-align-center">{t('Erhalte 100% auf deine erste Einzahlung geschenkt')}</small>
		</>

	}

	return <>
		<p className="reset-margin text-align-center">{t('40€ Geschenkt')}</p>
		<small className="text-align-center">{t('Für Erstkunden zum Erkunden')}</small>
	</>
};

export default UpsLivecamsText
